import styles from "../../pages/BlogArticle.module.scss";
import { shareLinks } from "./articleConstants";
import { useLanguage } from "../../contexts/LanguageContext";
import { blogText } from "../../i18n/blog";

const getArticleShareData = (article) => {
  const url = typeof window !== "undefined" ? window.location.href : "";

  const lang =
    typeof document !== "undefined" ? document.documentElement.lang : "ja";
  const textMapKey =
    lang === "en"
      ? "EN"
      : lang === "zh"
        ? "中文"
        : lang === "ko"
          ? "한국어"
          : "JP";
  const t = blogText[textMapKey] || blogText.JP;
  const title = article?.title || t.defaultShareTitle;
  const text = article?.description || t.defaultShareText;

  return {
    url,
    title,
    text,
  };
};

const getLineShareUrl = ({ url, title, text }) => {
  const shareText = [title, text, url].filter(Boolean).join("\n");

  return `https://line.me/R/msg/text/?${encodeURIComponent(shareText)}`;
};

const formatArticleId = (id) => {
  if (!id) return "01";

  return String(id).padStart(2, "0");
};

export function ArticleHeader({ article }) {
  const { lang } = useLanguage();
  const t = blogText[lang] || blogText.JP;
  const shareData = getArticleShareData(article);
  const introText = article.leadText || article.description;

  return (
    <>
      <div className={styles.sectionTitle}>
        <span>{formatArticleId(article.id)}</span>
        <small>Blog Guide</small>
        <h1>{article.title}</h1>
        {introText && <p>{introText}</p>}
      </div>

      <div className={styles.metaShareRow}>
        <div className={styles.meta}>
          <span>{article.date}</span>
          <span>
            {t.readTimePrefix} {article.readTime}
          </span>
          <span>{t.miyakojimaTag}</span>
          <span>#{article.category}</span>
        </div>

        <div className={styles.share}>
          <span>{t.share}</span>

          {shareLinks.map((link) => (
            <a
              key={link.type}
              href={getLineShareUrl(shareData)}
              target="_blank"
              rel="noreferrer"
              className={styles.line}
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </>
  );
}
